import { computed, inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { toSignal } from '@angular/core/rxjs-interop'
import { BehaviorSubject, lastValueFrom, map, Observable, of, take, tap, throwError } from 'rxjs'
import { CommonService } from '@appShared/services/common.service'
//import { AppFacade } from '@appShared/services/app.facade'
import {
   IAccount,
   IContact,
   IPaymentInstrument,
   IPaymentInstrumentSubmission,
   IProfile,
   IProfileSubmission,
   ISubscription,
   ISubscriptionPaymentTransaction,
   ISubscriptionAuthorization,
   IProgressBadge,
   ISubscriptionUpdateSubmission,
} from '@appShared/interfaces/[Model-based]'
import { IUser } from '@appShared/interfaces/[Interface-based]/user.interface'
import { environment } from '@appEnvironments/environment'

@Injectable({
   providedIn: 'root'
})
export class AccountsService {
   // services
   private _httpClient = inject(HttpClient)
   private _commonService = inject(CommonService)

   private _accountsApi = `${environment.apiConfig.endpointUri}/core/accounts`
   private _httpOptions = this._commonService.httpOptions()

   private _subscriptions: BehaviorSubject<
      ISubscription[]
   > = new BehaviorSubject<ISubscription[]>(null)
   public get subscriptions$(): Observable<ISubscription[]> {
      return this._subscriptions.asObservable()
   }

   private _subscriptionAuthorizations: BehaviorSubject<
      ISubscriptionAuthorization[]
   > = new BehaviorSubject<ISubscriptionAuthorization[]>(null)
   public get activeSubscriptionAuthorizations$(): Observable<ISubscriptionAuthorization[]> {
      return this._subscriptionAuthorizations.asObservable()
   }

   activeSubscriptionAuthorizations = toSignal(this.activeSubscriptionAuthorizations$)
   activePaymentInstrument = computed<IPaymentInstrument | undefined>(() => {
      const subscriptionAuthorizations = this.activeSubscriptionAuthorizations()
      return subscriptionAuthorizations?.length ? subscriptionAuthorizations[0].paymentInstrument : undefined
   })

   private _profiles: BehaviorSubject<
      IProfile[]
   > = new BehaviorSubject<IProfile[]>([])
   profiles = toSignal(this._profiles, { initialValue: [] })

   /*
   * private methods
   * */

   /*
   * public methods
   * */

   getCurrentUser(): Observable<IUser> {
      const url = `${this._accountsApi}/user`

      return this._httpClient.get<IUser>(url)
   }

   createUserWithToken(
      token: string,
      profileSubmission: IProfileSubmission
   ): Observable<number> {
      if (!token || !profileSubmission) {
         return throwError(() => new Error('No all token/profileSubmission passed!'))
         //return new Promise((resolve, reject) =>
         //   reject('No all token/profileSubmission passed!')
         //)
      }

      const url = `${this._accountsApi
         }/user?token=${token}`

      return this._httpClient.post<number>(
         url,
         profileSubmission,
         this._httpOptions
      )

      //const request$ = this._httpClient.post<number>(
      //   url,
      //   profileSubmission,
      //   this._httpOptions
      //).pipe(take(1))

      //return await lastValueFrom<number>(request$)
   }

   //subscriptionPaymentTransactions$(): Observable<ISubscriptionPaymentTransaction[]> {
   //   const url = `${this._accountsApi}/subscription-payment-transactions`

   //   return this._httpClient.get<ISubscriptionPaymentTransaction[]>(url)
   //      .pipe(
   //         map(subPayTrans => {
   //            subPayTrans.forEach(subPayTran => {
   //               subPayTran = this.getFormattedUpdatedPaymentInstrument(subPayTran.paymentTransaction)
   //            })

   //            return subPayTrans
   //         })
   //      )
   //}

   //getFormattedUpdatedPaymentInstrument(paymentInstrumentParent: any): any {
   //   let paymentInstrument = this._commonService.returnClientPaymentInstrument(paymentInstrumentParent.paymentInstrument)
   //   let paymentCard = paymentInstrument.paymentCard
   //   paymentInstrumentParent.paymentInstrument = {
   //      ...paymentInstrumentParent.paymentInstrument,
   //      paymentCard,
   //      paymentCardImageUrl: paymentInstrument.paymentCardImageUrl,
   //      sourceName: paymentInstrument.sourceName
   //   } as any /* any to account for expando property paymentCardImageUrl */

   //   return paymentInstrumentParent
   //}

   getNewProfile(): IProfile {
      return {
         id: 0,
         contact: {
            info: {}
         } as IContact,
         info: {}
      } as IProfile
   }

   getSubscriptions() {
      const url = `${this._accountsApi}/subscriptions`

      this._httpClient.get<ISubscription[]>(url).pipe(
         take(1)
      ).subscribe(subscriptions => {
         this._subscriptions.next(subscriptions)
      })
   }

   //prepareSubscriptionAuthorizations(subscriptionAuthorizations?: ISubscriptionAuthorization[]): void {
   //   if (!subscriptionAuthorizations) {
   //      subscriptionAuthorizations = []
   //   }

   //   subscriptionAuthorizations.forEach(subscription => {
   //      subscription = this.getFormattedUpdatedPaymentInstrument(subscription)
   //   })
   //   this._subscriptionAuthorizations.next([...subscriptionAuthorizations])
   //}

   //getActiveSubscriptionAuthorizations() {
   //   const url = `${this._accountsApi}/subscription-authorizations`

   //   this._httpClient.get<ISubscriptionAuthorization[]>(url).pipe(
   //      take(1)
   //   ).subscribe(subscriptionAuthorizations => {
   //      this.prepareSubscriptionAuthorizations([...subscriptionAuthorizations])
   //   })
   //}

   getProfiles(includeAccountOwner?: boolean, currentUser?: IUser) {
      const url = `${this._accountsApi}/profiles`

      //TODO - testing
      //let subscriptionSeats = [
      //   {
      //      id: 1234,
      //      profileId: 1234,
      //      profile: {
      //         contact: {
      //            id: 1234,
      //            firstName: 'Bubba',
      //            lastName: 'Johnson',
      //            emailAddress: 'bubba@johnson.com'
      //         } as IContact
      //      } as IProfile
      //   } as ISubscriptionSeat,
      //   {
      //      id: 2345,
      //      profileId: 2345,
      //      profile: {
      //         contact: {
      //            id: 2345,
      //            firstName: 'Jackie',
      //            lastName: 'Chan',
      //            emailAddress: 'jackie@chan.com'
      //         } as IContact
      //      } as IProfile
      //   } as ISubscriptionSeat,
      //   {
      //      id: 3456,
      //      profileId: 3456,
      //      profile: {
      //         contact: {
      //            id: 3456,
      //            firstName: 'Jojo',
      //            lastName: 'Smithersonstein',
      //            emailAddress: 'jojo@smithersonstein.com'
      //         } as IContact
      //      } as IProfile
      //   } as ISubscriptionSeat,
      //] as ISubscriptionSeat[]
      //this._subscriptionSeats.next(subscriptionSeats)


      /**
       * TODO - review for removal of nested subscription
       *    https://medium.com/@kateb.fedy/angular-best-practices-to-adapt-4c7687b16c85
       *    11. Avoid having Subscriptions Inside Subscriptions
       * */
      this._httpClient.get<IProfile[]>(url).pipe(
         take(1)
      ).subscribe(profiles => {
         if (!includeAccountOwner && currentUser) {

            const currentProfileId = (currentUser.profile as IProfile).id
            profiles = [...profiles].filter(profile => profile.id !== currentProfileId)
            this._profiles.next(profiles)

         } else {
            this._profiles.next(profiles)
         }
      })
   }

   getProfileBadges(profileId: number): Observable<IProgressBadge[]> {

      if (profileId) {
         const url = `${this._accountsApi}/profiles/${profileId}/badges`

         return this._httpClient.get<IProgressBadge[]>(url)
      }

      return of([])
   }

   async createUpdateProfile(profileSubmission: IProfileSubmission, profileId?: number): Promise<any> {

      if (!profileSubmission) {
         return Promise.reject('No profileSubmission passed!')
      }

      let url = `${this._accountsApi}/profiles`
      const options = this._commonService.httpOptions()
      let request$: Observable<IProfile>

      if (profileId) {
         /* update */
         url = `${url}/${profileId}`
         request$ = this._httpClient.put<IProfile>(url, profileSubmission, options).pipe(take(1))
      } else {
         /* else create */
         request$ = this._httpClient.post<IProfile>(url, profileSubmission, options).pipe(take(1))
      }

      return await lastValueFrom<IProfile>(request$)
   }

   async deleteProfile(
      profileId: number
   ): Promise<any> {
      if (!profileId) {
         return Promise.reject('profileId NOT passed!')
      }

      const url = `${this._accountsApi}/profiles/${profileId}`

      const request$ = this._httpClient.delete(url, this._httpOptions).pipe(take(1))

      return await lastValueFrom(request$)
   }

   //async updateSubscriptionAuthorizations(
   //   paymentInstrumentSubmission: IPaymentInstrumentSubmission
   //): Promise<IAccount> {
   //   if (!paymentInstrumentSubmission) {
   //      return Promise.reject('Not all paymentInstrumentSubmission passed!')
   //   }

   //   const url = `${this._accountsApi}/subscription-authorizations`

   //   const request$ = this._httpClient.put<IAccount>(url, paymentInstrumentSubmission, this._httpOptions).pipe(take(1))

   //   return await lastValueFrom<IAccount>(request$)
   //}

   updateSubscriptionAuthorizations(
      paymentInstrumentSubmission: IPaymentInstrumentSubmission
   ): Observable<IAccount> {
      if (!paymentInstrumentSubmission) {
         return throwError(() => new Error('Not all paymentInstrumentSubmission passed!'))
      }

      const url = `${this._accountsApi}/subscription-authorizations`

      return this._httpClient.put<IAccount>(url, paymentInstrumentSubmission, this._httpOptions)
   }

   async updateSubscription(
      subscriptionUpdateSubmission: ISubscriptionUpdateSubmission
   ): Promise<ISubscription> {
      if (!subscriptionUpdateSubmission?.subscriptionId) {
         return Promise.reject('Not all subscriptionUpdateSubmission passed!')
      }

      const url = `${this._accountsApi}/subscriptions/${subscriptionUpdateSubmission.subscriptionId}`

      const request$ = this._httpClient.put<ISubscription>(url, subscriptionUpdateSubmission, this._httpOptions).pipe(take(1))

      return await lastValueFrom<ISubscription>(request$)
   }

   async resetPassword(password: string): Promise<any> {
      if (!password) {
         return new Promise((resolve, reject) => reject('No password passed!'))
      }

      const url = `${this._accountsApi}/set-password`

      const request$ = this._httpClient.put(url, { password }, this._commonService.httpOptions()).pipe(take(1))

      return await lastValueFrom(request$)
   }
}
